import {AiOutlineLinkedin,AiOutlineGithub, AiOutlineGoogle} from 'react-icons/ai'
const HeaderSocials = () => {
  return (
    <div className="header_socials">
        <a href="https://www.linkedin.com/in/haowei-lou-0088201b0/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><AiOutlineLinkedin /> LinkedIn</a>
        <a href="https://github.com/haoweilou" target="_blank" rel="noreferrer" aria-label="GitHub"><AiOutlineGithub /> GitHub</a>
        <a href="https://scholar.google.com/citations?user=L16GPD0AAAAJ" target="_blank" rel="noreferrer" aria-label="Google Scholar"><AiOutlineGoogle /> Scholar</a>
    </div>
  )
}

export default HeaderSocials
